// extracted by mini-css-extract-plugin
export default {"button":"rO6UY","button-wide":"mB5R7"};